import React from 'react';
import PropTypes from 'prop-types';
import { MiniPanel } from '@cgn/framework-ui-components/v2';

/**
 */
const InfoModaleQuesito = ({ infoModaleQuesito }) => {
  if (!infoModaleQuesito) return null;

  const type = typeof infoModaleQuesito === 'string' ? 'info' : infoModaleQuesito.type;
  const htmlMessage = typeof infoModaleQuesito === 'string'
    ? infoModaleQuesito
    : infoModaleQuesito.htmlMessage;
  return (
    <MiniPanel
      className="helpdesk-frontend-modale__info"
      type={type}
      message={htmlMessage
        .split('\n')
        // eslint-disable-next-line react/no-array-index-key, react/no-danger
        .map((t, i) => (
          <p
            // eslint-disable-next-line react/no-array-index-key
            key={i}
            className="modaleQuesito__paragrofo_info"
            dangerouslySetInnerHTML={{ __html: t }}
          />
        ))}
    />
  );
};

InfoModaleQuesito.propTypes = {
  infoModaleQuesito: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      htmlMessage: PropTypes.string.isRequired,
    }),
  ]),
};

InfoModaleQuesito.defaultProps = {
  infoModaleQuesito: undefined,
};

export default InfoModaleQuesito;
